import { PEAD } from "../../../consts";

export function getColorForCurrentPead(
	d:
		| ([number, number, string][] & {
				z: string;
		  })
		| { z: string },
	points: [number, number, string][],
) {
	const uniquePeads = [...new Set(points?.map((point) => point[2]))].reverse();
	const currentPead = uniquePeads[0];
	const recentPeads = uniquePeads.slice(0, 5);

	switch (d.z) {
		case currentPead:
			return PEAD.CURRENT_PEAD_COLOR;
		case recentPeads[1]:
		case recentPeads[2]:
		case recentPeads[3]:
		case recentPeads[4]:
			return PEAD.LAST_4_QTR_COLOR;
		default:
			return PEAD.DEFAULT_PEAD_COLOR;
	}
}
